import React from "react";
import MainTable from '../../Components/Tables/Main/MainTable'
import { useAgreements } from "../../Hooks/useAgreements";
import { useCompanies } from "../../Hooks/useCompanies";
import { resolveTimezoneOffsetError } from "../../CommonConstants";
// Libraries
import DateFnsUtils from '@date-io/date-fns';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { useHistory } from "react-router-dom";
import { VpnKey } from "@material-ui/icons";

const Agreements = () => {
  const [agreementsData, addAgreement, updateAgreement, deleteAgreement] = useAgreements();
  let [companies] = useCompanies();
  companies = companies.reduce(
    function (acc, cur) {
      const { id, name } = cur;
      acc[id] = name;
      return acc;
    },
    {}
  );

  const columns = [
    { title: "Número de acuerdo", field: "id", editable: "never", defaultSort: 'desc' },
    { title: "Empresa", field: "companyName", editable: "onAdd", lookup: companies },
    {
      title: "Fecha de inicio", field: "initDate", type: "date",
      render: row => row.initDate ? <span>{resolveTimezoneOffsetError(row.initDate, 'dd/MM/yyyy')}</span> : <span></span>,
      editComponent: props => (
        <MuiPickersUtilsProvider utils={DateFnsUtils}
          locale={props.dateTimePickerLocalization}>
          <DatePicker
            format="dd/MM/yyyy"
            value={props.value ? resolveTimezoneOffsetError(props.value) : null}
            onChange={props.onChange}
            clearable
            InputProps={{
              style: {
                fontSize: 13,
              }
            }}
          />
        </MuiPickersUtilsProvider>
      )
    },
    {
      title: "Fecha de Fin", field: "endDate", type: "date",
      render: row => row.endDate ? <span>{resolveTimezoneOffsetError(row.endDate, 'dd/MM/yyyy')}</span> : <span></span>,
      editComponent: props => (
        <MuiPickersUtilsProvider utils={DateFnsUtils}
          locale={props.dateTimePickerLocalization}>
          <DatePicker
            format="dd/MM/yyyy"
            value={props.value ? resolveTimezoneOffsetError(props.value) : null}
            onChange={props.onChange}
            clearable
            InputProps={{
              style: {
                fontSize: 13,
              }
            }}
          />
        </MuiPickersUtilsProvider>
      )
    }
  ];
  const history = useHistory();

  const actions = [{
    icon: VpnKey,
    tooltip: "Ver arrendamientos",
    onClick: (event, agreement) => {
      history.push(`/leases/${agreement.id}`);
    },
  }];

  return <MainTable
    title="Acuerdos Comerciales"
    columns={columns}
    actions={actions}
    data={agreementsData}
    requiredFields={["companyName", "initDate", "endDate"]}
    deleteText="Se borraran todos los arrendamientos asociados"
    onRowAdd={addAgreement}
    onRowUpdate={updateAgreement}
    onRowDelete={deleteAgreement}
  />
}

export default Agreements


// WEBPACK FOOTER //
// ./src/Containers/Agreements/Agreements.js